"use strict";
/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnownProvisioning = exports.KnownCreatedByType = exports.KnownAcceptOwnership = exports.KnownProvisioningState = exports.KnownWorkload = void 0;
/** Known values of {@link Workload} that the service accepts. */
var KnownWorkload;
(function (KnownWorkload) {
    /** Production */
    KnownWorkload["Production"] = "Production";
    /** DevTest */
    KnownWorkload["DevTest"] = "DevTest";
})(KnownWorkload || (exports.KnownWorkload = KnownWorkload = {}));
/** Known values of {@link ProvisioningState} that the service accepts. */
var KnownProvisioningState;
(function (KnownProvisioningState) {
    /** Accepted */
    KnownProvisioningState["Accepted"] = "Accepted";
    /** Succeeded */
    KnownProvisioningState["Succeeded"] = "Succeeded";
    /** Failed */
    KnownProvisioningState["Failed"] = "Failed";
})(KnownProvisioningState || (exports.KnownProvisioningState = KnownProvisioningState = {}));
/** Known values of {@link AcceptOwnership} that the service accepts. */
var KnownAcceptOwnership;
(function (KnownAcceptOwnership) {
    /** Pending */
    KnownAcceptOwnership["Pending"] = "Pending";
    /** Completed */
    KnownAcceptOwnership["Completed"] = "Completed";
    /** Expired */
    KnownAcceptOwnership["Expired"] = "Expired";
})(KnownAcceptOwnership || (exports.KnownAcceptOwnership = KnownAcceptOwnership = {}));
/** Known values of {@link CreatedByType} that the service accepts. */
var KnownCreatedByType;
(function (KnownCreatedByType) {
    /** User */
    KnownCreatedByType["User"] = "User";
    /** Application */
    KnownCreatedByType["Application"] = "Application";
    /** ManagedIdentity */
    KnownCreatedByType["ManagedIdentity"] = "ManagedIdentity";
    /** Key */
    KnownCreatedByType["Key"] = "Key";
})(KnownCreatedByType || (exports.KnownCreatedByType = KnownCreatedByType = {}));
/** Known values of {@link Provisioning} that the service accepts. */
var KnownProvisioning;
(function (KnownProvisioning) {
    /** Pending */
    KnownProvisioning["Pending"] = "Pending";
    /** Accepted */
    KnownProvisioning["Accepted"] = "Accepted";
    /** Succeeded */
    KnownProvisioning["Succeeded"] = "Succeeded";
})(KnownProvisioning || (exports.KnownProvisioning = KnownProvisioning = {}));
//# sourceMappingURL=index.js.map